import { defineStore } from 'pinia';
import type { AdminPermission, AdminView } from 'shared';
import { adminApi, onAdminTokenChange, setAdminToken } from '@/api';

export const useAdminSessionStore = defineStore('admin-session', {
  state: () => ({
    profile: null as AdminView | null,
    loading: false,
    initialized: false,
  }),
  getters: {
    permissions: (state): AdminPermission[] => state.profile?.permissions ?? [],
    hasSession: () => Boolean(sessionStorage.getItem('adminAccessToken')),
  },
  actions: {
    async ensureProfile(): Promise<AdminView | null> {
      if (!this.hasSession) {
        this.profile = null;
        this.initialized = true;
        return null;
      }
      if (this.profile) return this.profile;
      if (this.loading) return this.profile;
      this.loading = true;
      try {
        this.profile = (await adminApi.me()) as AdminView;
        return this.profile;
      } catch {
        setAdminToken(null);
        this.profile = null;
        return null;
      } finally {
        this.loading = false;
        this.initialized = true;
      }
    },
    can(permission?: AdminPermission): boolean {
      return !permission || this.permissions.includes(permission);
    },
    reset(): void {
      this.profile = null;
      this.initialized = false;
    },
  },
});

onAdminTokenChange((token) => {
  if (!token) useAdminSessionStore().reset();
});
